/* eslint-disable no-undef */

export default {
	name: "error-modal",
	props: ["modalHeading", "elementId", "modalMessage", "showModal"],
	emits: ["okClicked"],
	data() {
		return {
			selectElementId: "select",
			selectedValue: null
		};
	},
	methods: {
		closeModal() {
			this.$emit("okClicked", true);
		}
	},
	mounted: function () {
        
	},
	watch: {
		showModal: {
			handler: function () {
				if (this.showModal) {
					$("#" + this.elementId).modal("show");
				}
			}
		}
	}
};
